/*
 * Optional B2B enhancement. Links and Shopify contact forms remain native.
 *
 * Analytics contract: dataLayer and the document's `postera:b2b` CustomEvent
 * carry only { event, cta_location }. Integrations should consume ONE sink;
 * this asset never calls gtag. Shopify's analytics consent gates both sinks
 * whenever its privacy API is available. Denied events are not replayed.
 *
 * Render [data-b2b-success] only for form.posted_successfully? and
 * [data-b2b-error] only for form.errors, inside form[data-b2b-form].
 */
(function () {
  'use strict';

  if (window.__posteraB2BInitialized) return;
  window.__posteraB2BInitialized = true;

  const submissionKey = 'postera:b2b:pending-submission';
  const submissionLifetime = 30 * 60 * 1000;
  const initializedForms = new WeakSet();
  const locations = ['hero', 'pathways', 'projects', 'faire', 'benefits', 'faq', 'contact', 'sticky'];

  function isDesignMode() {
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  function analyticsAllowed() {
    if (isDesignMode()) return false;
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !privacy || typeof privacy.analyticsProcessingAllowed !== 'function' ||
        privacy.analyticsProcessingAllowed() === true;
    } catch (_) {
      return false;
    }
  }

  function track(event, location) {
    if (!analyticsAllowed()) return;

    // Isolate integrations: a broken analytics sink must not break navigation.
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: event, cta_location: location });
    } catch (_) { /* The native page continues without this analytics sink. */ }

    try {
      document.dispatchEvent(new CustomEvent('postera:b2b', {
        detail: { event: event, cta_location: location }
      }));
    } catch (_) { /* The native page continues without the optional hook. */ }
  }

  function consumeSubmission() {
    try {
      const storage = window.sessionStorage;
      const value = storage.getItem(submissionKey);
      // Consume before emitting, including on errors or consent revocation.
      storage.removeItem(submissionKey);
      if (!value || !/^\d+$/.test(value)) return false;
      const age = Date.now() - Number(value);
      return age >= 0 && age <= submissionLifetime;
    } catch (_) {
      // Without storage, do not guess whether this is a fresh conversion.
      return false;
    }
  }

  function initialize(root, isPostedResponse) {
    const forms = Array.from(root.querySelectorAll('form[data-b2b-form]'));
    if (root.matches && root.matches('form[data-b2b-form]')) forms.unshift(root);

    forms.forEach(function (form) {
      if (initializedForms.has(form)) return;
      initializedForms.add(form);
      // Editor section rendering is not evidence of a successful contact post.
      if (!isPostedResponse || isDesignMode()) return;

      const error = form.querySelector('[data-b2b-error]');
      const success = form.querySelector('[data-b2b-success]');
      const status = error || success;
      if (!status) return;

      const submittedHere = consumeSubmission();
      if (!status.hasAttribute('tabindex')) status.setAttribute('tabindex', '-1');
      status.focus();
      if (success && !error && submittedHere) track('b2b_form_submit', 'form');
    });
  }

  document.addEventListener('click', function (event) {
    const target = event.target;
    const link = target && target.closest && target.closest('a[data-b2b-event]');
    if (!link) return;

    const name = link.getAttribute('data-b2b-event');
    if (name !== 'b2b_quote_cta_click' && name !== 'b2b_faire_cta_click') return;

    const location = link.getAttribute('data-b2b-location');
    // Never forward link text, URLs, form values, or arbitrary attribute text.
    track(name, locations.indexOf(location) === -1 ? 'unknown' : location);
  });

  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form || !form.matches || !form.matches('form[data-b2b-form]')) return;

    // Wait for other submit listeners, without cancelling the native POST.
    Promise.resolve().then(function () {
      if (event.defaultPrevented || isDesignMode()) return;
      try {
        const storage = window.sessionStorage;
        storage.removeItem(submissionKey);
        if (analyticsAllowed()) storage.setItem(submissionKey, String(Date.now()));
      } catch (_) { /* Browser storage is optional; the form remains native. */ }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document, true);
    }, { once: true });
  } else {
    initialize(document, true);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target, false);
  });
})();
